import { createServerFn } from "@tanstack/react-start";
import { registrarLog } from "@/lib/log-servidor.server";

/**
 * Recebe erros não tratados do navegador e os registra no diário de bordo
 * do servidor para diagnóstico. É pública: pode ser chamada antes do login,
 * inclusive pelo script inline injetado no shell (`/_serverFn/enviarErroCliente`).
 */
export const enviarErroCliente = createServerFn({ method: "POST" })
  .validator((input: { message?: string; details?: string } | undefined) => ({
    message: String(input?.message ?? "erro").slice(0, 500),
    details: input?.details ? String(input.details).slice(0, 4000) : undefined,
  }))
  .handler(async ({ data }): Promise<{ ok: true }> => {
    registrarLog("cliente", data.message, { nivel: "erro", detalhes: data.details });
    return { ok: true };
  });
